// script lib - console log
const logError = (data) => {
	if(window.context && window.context.isDevelopment){
		console.error(data);
	}
};

const logInfo = (data) => {
	if(window.context && window.context.isDevelopment){
		console.info(data);
	}
};

export { logError, logInfo };
